import {INITIAL_LOAD_STATUS_SUBSTATE, LoadStatusSubstate} from '@aviary/store/store.types';
import {ActionReducer, createReducer, on} from '@ngrx/store';
import {FAILED, LOADED, LOADING, RELOADING} from '@aviary/store/common/common.types';
import {ItemRequest} from '@store/item-requests/item-requests.types';
import {ItemRequestsActions} from '@store/item-requests/item-requests.actions';

export interface ItemRequestsState {
  current: LoadStatusSubstate & {
    data?: ItemRequest;
  };
  activeItemRequests: LoadStatusSubstate & {
    data: ItemRequest[];
    requestCount: number;
  };
  closedItemRequests: LoadStatusSubstate & {
    data: ItemRequest[];
    requestCount: number;
  };
}

export const INITIAL_ITEM_REQUESTS_STATE: ItemRequestsState = {
  current: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: undefined,
  },
  activeItemRequests: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
    requestCount: 0
  },
  closedItemRequests: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
    requestCount: 0
  }
};

export const itemRequestsState: ActionReducer<ItemRequestsState> = createReducer(
  INITIAL_ITEM_REQUESTS_STATE,
  on(ItemRequestsActions.loadActiveItemRequests, state => ({
    ...state,
    activeItemRequests: {
      ...state.activeItemRequests,
      loadStatus: LOADING
    }
  })),
  on(ItemRequestsActions.loadActiveItemRequestsSuccess, (state, {listData: {data, paginationInfo: {totalCount} = {totalCount: 0}}}) => ({
    ...state,
    activeItemRequests: {
      loadStatus: LOADED,
      data,
      requestCount: totalCount
    }
  })),
  on(ItemRequestsActions.loadActiveItemRequestsFailure, state => ({
    ...state,
    activeItemRequests: {
      ...INITIAL_ITEM_REQUESTS_STATE.activeItemRequests,
      loadStatus: FAILED,
    }
  })),

  on(ItemRequestsActions.loadClosedItemRequests, state => ({
    ...state,
    closedItemRequests: {
      ...state.closedItemRequests,
      loadStatus: LOADING
    }
  })),
  on(ItemRequestsActions.loadClosedItemRequestsSuccess, (state, {listData: {data, paginationInfo: {totalCount} = {totalCount: 0}}}) => ({
    ...state,
    closedItemRequests: {
      loadStatus: LOADED,
      data,
      requestCount: totalCount
    }
  })),
  on(ItemRequestsActions.loadClosedItemRequestsFailure, state => ({
    ...state,
    closedItemRequests: {
      ...INITIAL_ITEM_REQUESTS_STATE.closedItemRequests,
      loadStatus: FAILED,
    }
  })),
  on(ItemRequestsActions.loadItemRequestDetails, (state, {id}) => {
    const reloading: boolean = state.current.data?.id === id;
    return {
      ...state,
      current: {
        ...state.current,
        data: reloading ? state.current.data : undefined,
        loadStatus: reloading ? RELOADING : LOADING
      }
    };
  }),
  on(ItemRequestsActions.loadItemRequestDetailsSuccess, (state, {itemRequest}) => ({
    ...state,
    current: {
      ...state.current,
      loadStatus: LOADED,
      data: itemRequest
    }
  })),
  on(ItemRequestsActions.loadItemRequestDetailsFailure, state => ({
    ...state,
    current: {
      ...state.current,
      loadStatus: FAILED
    }
  }))
);
